import React, { useState } from 'react';
import { BsFileText } from 'react-icons/bs'; // Changed to use BsFileText from react-icons/bs
import TableComponent from './../../components/widgets/table/index';

function Invoices() {
  const allInvoiceData = [
    { id: 1, invoiceNumber: 'INV001', amount: 1250.00, customer: 'Alice Johnson', status: 'Paid', date: '2025-01-15' },
    { id: 2, invoiceNumber: 'INV002', amount: 800.50, customer: 'Bob Smith', status: 'Due', date: '2025-01-20' },
    { id: 3, invoiceNumber: 'INV003', amount: 300.00, customer: 'Charlie Brown', status: 'Paid', date: '2025-02-01' },
    { id: 4, invoiceNumber: 'INV004', amount: 1500.75, customer: 'Diana Prince', status: 'Overdue', date: '2025-02-10' },
    { id: 5, invoiceNumber: 'INV005', amount: 500.00, customer: 'Eve Adams', status: 'Paid', date: '2025-03-05' },
    { id: 6, invoiceNumber: 'INV006', amount: 950.20, customer: 'Frank White', status: 'Due', date: '2025-03-12' },
    { id: 7, invoiceNumber: 'INV007', amount: 200.00, customer: 'Grace Lee', status: 'Paid', date: '2025-04-01' },
    { id: 8, invoiceNumber: 'INV008', amount: 1100.00, customer: 'Harry Potter', status: 'Due', date: '2025-04-25' },
    { id: 9, invoiceNumber: 'INV009', amount: 450.00, customer: 'Ivy Green', status: 'Paid', date: '2025-05-01' },
    { id: 10, invoiceNumber: 'INV010', amount: 700.00, customer: 'Jack Sparrow', status: 'Due', date: '2025-05-15' },
    { id: 11, invoiceNumber: 'INV011', amount: 1800.00, customer: 'Karen Black', status: 'Overdue', date: '2025-06-01' },
    { id: 12, invoiceNumber: 'INV012', amount: 600.00, customer: 'Liam Neeson', status: 'Paid', date: '2025-06-20' },
    { id: 13, invoiceNumber: 'INV013', amount: 900.00, customer: 'Mia Turner', status: 'Due', date: '2025-07-05' },
    { id: 14, invoiceNumber: 'INV014', amount: 100.00, customer: 'Noah King', status: 'Paid', date: '2025-07-10' },
    { id: 15, invoiceNumber: 'INV015', amount: 1300.00, customer: 'Olivia Queen', status: 'Due', date: '2025-08-01' },
    { id: 16, invoiceNumber: 'INV016', amount: 750.00, customer: 'Peter Pan', status: 'Paid', date: '2025-08-14' },
    { id: 17, invoiceNumber: 'INV017', amount: 999.00, customer: 'Quinn Jones', status: 'Due', date: '2025-09-05' },
    { id: 18, invoiceNumber: 'INV018', amount: 250.00, customer: 'Rachel Ray', status: 'Paid', date: '2025-09-10' },
  ];

  const months = [
    { name: 'January', value: 0 }, { name: 'February', value: 1 }, { name: 'March', value: 2 },
    { name: 'April', value: 3 }, { name: 'May', value: 4 }, { name: 'June', value: 5 },
    { name: 'July', value: 6 }, { name: 'August', value: 7 }, { name: 'September', value: 8 },
    { name: 'October', value: 9 }, { name: 'November', value: 10 }, { name: 'December', value: 11 }
  ];

  const currentMonth = new Date().getMonth();
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [showCards, setShowCards] = useState(true);

  const filteredInvoiceData = allInvoiceData.filter(item => {
    const itemMonth = new Date(item.date).getMonth();
    return itemMonth === selectedMonth;
  });

  const getCountForMonth = (monthValue) => {
    return allInvoiceData.filter(item => new Date(item.date).getMonth() === monthValue).length;
  };

  const invoiceTableFields = [
    { name: 'Invoice Number' },
    { name: 'Amount' },
    { name: 'Customer' },
    { name: 'Status' },
    { name: 'Date' },
  ];

  const invoiceRowData = [
    { type: 'text', field: 'invoiceNumber' },
    { type: 'currency', field: 'amount' },
    { type: 'text', field: 'customer' },
    { type: 'status', field: 'status' },
    { type: 'date', field: 'date' },
  ];

  const handleMonthClick = (monthValue) => {
    setSelectedMonth(monthValue);
    setShowCards(false);
  };

  return (
    <div className="min-vh-100 bg-light pb-5">
      <div className="bg-white container">
        <div className="container py-4">
          <h1 className="h3 font-weight-bold text-dark">Invoices</h1>
          <p className="text-muted mb-0">Overview of all invoices by month.</p>
        </div>
      </div>

      <div className="container py-5">
        {showCards ? (
          <div className="d-flex flex-wrap justify-content-start align-items-stretch" style={{ gap: '2rem' }}>
            {months.map((month, index) => (
              <div key={index} style={{ flex: '0 0 calc(25% - 1.5rem)', maxWidth: 'calc(25% - 1.5rem)', marginTop: '2rem' }}>
                <div
                  className="card h-100 border-0 #shadow-sm text-center py-4 cursor-pointer rounded"
                  onClick={() => handleMonthClick(month.value)}
                >
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center mb-2"
                      style={{ backgroundColor: '#3b82f6', width: '64px', height: '64px' }} // Invoices color from Reports page
                    >
                      <BsFileText className="text-white" size={32} />
                    </div>
                    <h2 className="font-weight-bold mb-0 text-dark">{getCountForMonth(month.value)}</h2>
                    <p className="card-text mt-2 mb-0 text-dark">{month.name}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <TableComponent
            title={`Invoices for ${months[selectedMonth].name}`}
            table_fields={invoiceTableFields}
            row_data={invoiceRowData}
            table_data={filteredInvoiceData}
          />
        )}
      </div>
    </div>
  );
}

export default Invoices;
